import React from "react";
import Agents from "../modules/Agents/Agents";

export default function AgentsPage() {
  return <Agents />;
}
